import { render } from "./beijia.vue?vue&type=template&id=769327c6&scoped=true"
import script from "./beijia.vue?vue&type=script&lang=js"
export * from "./beijia.vue?vue&type=script&lang=js"

import "./beijia.vue?vue&type=style&index=0&id=769327c6&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769327c6"]])

export default __exports__